/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LocationHierarchyFilterDto { 
    /**
     * Administrative level used for containment search
     */
    level: LocationHierarchyFilterDto.LevelEnum;
    placeId?: string;
    name?: string;
    countryCode?: string;
}
export namespace LocationHierarchyFilterDto {
    export type LevelEnum = 'city' | 'department' | 'region' | 'country';
    export const LevelEnum = {
        City: 'city' as LevelEnum,
        Department: 'department' as LevelEnum,
        Region: 'region' as LevelEnum,
        Country: 'country' as LevelEnum
    };
}


